import React, { ReactNode } from "react";
import { QuantityContainer, ContainerQty } from "./styles";
import { Delete } from "./Delete";
import { ProductObservation } from "./ProductObservation";
import { QuantityAddition } from "./QuantityAddition";
import { QuantitySubtraction } from "./QuantitySubtraction";
import { QuantityValue } from "./QuantityValue";

interface IProductCardActionsRoot {
  children: ReactNode;
}

function ProductCardActionsRoot({ children }: IProductCardActionsRoot) {

  return (
    <ContainerQty>
      <QuantityContainer>
        {children}
      </QuantityContainer>
    </ContainerQty>
  )
}

export const ProductCardActions = {
  Root: ProductCardActionsRoot,
  Delete: Delete,
  Observation: ProductObservation,
  Addtion: QuantityAddition,
  Subtraction: QuantitySubtraction,
  value: QuantityValue,
}

